module.exports = __webpack_public_path__ + "img/banner.b85a2ef2.png";